import gsap from 'gsap'; 
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle'; 
gsap.registerPlugin(ScrollTrigger);

export default class CarouselParallax{
    constructor(){

        this.carousel = {
            element: document.querySelector('.carousel[data-carousel="parallax"]'),  
            wrapper: document.querySelector('section.slider-parallax .wrapper'),
        }

        this.createGsapCarousel(this.carousel.element); // Init Carousel
    }


    createGsapCarousel(target){
        this.carousel.element.classList.add('swiper');
        this.carousel.wrapper.classList.add('swiper-wrapper');
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: false,
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }

        ScrollTrigger.matchMedia({
            // < Laptop
            "(max-width: 570px)" : () => {
                // ScrollTrigger.kill('rooms');
                gsap.set(this.carousel.wrapper, { x: 0 });
            }, 
            // > Laptop
            '(min-width: 571px)' : () => {
                let timeline = gsap.timeline({
                    defaults: { ease: 'linear' }
                });
                
                this.createTriggers(timeline);

                gsap.set(this.carousel.wrapper, { x: this.carousel.wrapper.clientWidth / (this.carousel.wrapper.children.length + 1) });

                timeline.to(this.carousel.wrapper, {
                    x: - (this.carousel.wrapper.clientWidth / (this.carousel.wrapper.children.length + 1)),
                });
            }
        });
     
    }

    createTriggers(animation) {
        ScrollTrigger.create({
            id: 'rooms',
            animation: animation,
            trigger: this.carousel.element.parentNode,
            start: "top bottom",
            end: "bottom top+=20%",
            scrub: 1,
            // markers: true
        });
    }
}
